import React from "react";
import ReactDOM from "react-dom/client";
import { applyDocumentBranding } from "@/config/branding";
import "@/i18n";
import "@/index.css";
import App from "@/App";

applyDocumentBranding();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
